import React, { useEffect, useRef, useState } from 'react';
import Modal from '@mui/material/Modal';
import { jsonEditorStyles } from '../jsonEditorStyles';
import cn from 'clsx';
import Button from '@mui/material/Button';
import { TextComponent } from '../../uiComponents';
import ClearOutlinedIcon from '@mui/icons-material/ClearOutlined';
import { Box, Typography } from '@mui/material';

interface NewFlowchartModalProps {
    closeComponent: Function
}

const NewFlowchartModal = ({
    closeComponent
}: NewFlowchartModalProps) => {
    const classes: any = jsonEditorStyles();
    const [newChartName, setNewChartName] = useState<string>('');

    return (
        <Modal
            disablePortal
            disableEnforceFocus
            disableAutoFocus
            open
            onClose={(event, reason) => {
                if (reason !== 'backdropClick') {
                    closeComponent(null);
                }
            }}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            className={classes.modalStyle}
        >
            <div className={classes.smallPopup}>
                <Box sx={{ display: 'flex', flexDirection: 'column', mx: 2, mt: 2, alignItems: 'center' }}>
                    <Typography variant='h5' sx={{alignSelf: 'flex-start', mb: 1}}>
                        Add Flowchart
                    </Typography>
                    <TextComponent
                        changeHandler={(e) => {
                            setNewChartName(e.target.value);
                        }}
                        data={{
                            label: 'New Flowchart Name',
                            value: newChartName
                        }}
                    />
                    <Box sx={{ width: '90%', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            sx={{ my: 2 }}
                            onClick={(e) => {
                                closeComponent(newChartName);
                            }}
                            disabled={!newChartName}
                        >
                            Create
                        </Button>
                        <Button
                            variant="contained"
                            color="error"
                            sx={{ my: 2 }}
                            onClick={(e) => {
                                closeComponent(null);
                            }}
                        >
                            Cancel
                        </Button>
                    </Box>
                </Box>
            </div>
        </Modal>
    )
} 

export default NewFlowchartModal